import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as CreditCardMdl from '../models/CreditCardModelFS';
import * as myCfg from '../AppConfig';
import { APIContainer, LogTypes, sawinFunc } from './sawinLib';
import { SessionModel } from '../models/SessionModel';
import * as ARInvoiceMdl from '../models/ArInvoiceModel';
import { Console } from 'console';
// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface ChargeCreditCardFS { type: 'CREDITCARD_FS_CHARGERESULT', newState: CreditCardMdl.CreditCardFSProcess }
export interface ChargeCreditProcessingFS { type: 'CREDITCARD_FS_PROCESSING' }
export interface ChargeCreditErrorFS { type: 'CREDITCARD_FS_ERROR', error: string }
export interface ChargeCreditResetFS { type: 'CREDITCARD_FS_RESETINFO' }
export interface CreditCardsLoadingFS { type: 'CREDITCARDS_LOADING' }
export interface CreditCardsLoadFS { type: 'CREDITCARDS_FS_LOAD', newState: CreditCardMdl.CreditCardModel[] }
export interface CreditCardsAuthKeyLoaded { type: 'CREDITCARDS_FS_AK_LOADED', authKey: string, hostedFormScript: string  }

export type KnownAction = ChargeCreditCardFS | ChargeCreditProcessingFS | ChargeCreditErrorFS | ChargeCreditResetFS | CreditCardsLoadingFS | CreditCardsLoadFS | CreditCardsAuthKeyLoaded;

export const actionCreators = {
    chargeCreditCard: (sequence: number): AppThunkAction<KnownAction> => (dispatch, getState) => {

        console.log("ChargeCreditCard IN")
        const appState = getState();
        const sessionState = appState.sessionState;
        const invoicesAR: ARInvoiceMdl.ArInvoiceModel[] = appState.openInvoicesState.items.filter(x => x.isSelectedToPay == true);
        var ChargeInvoiceMdl: CreditCardMdl.ChargeWithTokenMultipleRecordsPayload = CreditCardMdl.initialStateChargeWithTokenMultipleRecordsPayload;
        var invoicesToCharge: CreditCardMdl.ChargeWithTokenInvoice[] = [];
        var totalAmount: number = 0;
        var fee: number = 0;
        invoicesToCharge = invoicesAR.map((item, index) => {
            totalAmount += item.balanceDue;
            fee += item.programFee;
            //
            return {
                invoiceNum: item.invoiceNumber,
                amount: item.balanceDue,
                programFee: item.programFee,
                module: 'AR' //item.module          

            };
        });
       
        if (fee > 0) {
            totalAmount += fee;
        }

        console.log(invoicesToCharge);

        ChargeInvoiceMdl = {
            ...CreditCardMdl.initialStateChargeWithTokenMultipleRecordsPayload, ...{
                invoices: invoicesToCharge,
                companyCode: sessionState.SelectedAR.companyCode,
                entityCode: 'Customer',
                entityType: 'C',
                amountToCharge: totalAmount,
                sequence: sequence,
                billTo: sessionState.SelectedAR.id,
                userNumber: '',
                userName:'CUSTOMER-PORTAL',
                sendReceiptToEmail: '',
                sendReceiptToPhone: '',
                userType: 'C',
                transactionFee:fee,
                comments:''
            }
        };

        dispatch({ type: 'CREDITCARD_FS_PROCESSING' });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/Proxy/FullSteamChargeWithToken',
            {
                method: 'POST',
                body: JSON.stringify(ChargeInvoiceMdl),
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
           
                console.log(container.data);
                const data: CreditCardMdl.ChargeWithTokenResult = { ...container.data };

                //var notProcessed: number = 0;
                //var totalInvoices: number = data.invoices.length;

                //data.invoices.forEach((item, index) => {
                //    if (!item.autCode || item.autCode.length == 0) {
                //        notProcessed++;
                //    }
                //});

                var creditCardResult: CreditCardMdl.CreditCardFSProcess = { ...CreditCardMdl.CreditCardProcessIntialState };
                console.log(`Data Success ${data.success}`)
                console.log(`Error ${container.errorInfo ? container.errorInfo.message : ''}`)
              
                creditCardResult.error = container.errorInfo ? container.errorInfo.message : '';                
                creditCardResult.success = data.success;
                creditCardResult.receiptLink = data.receiptLink;
                creditCardResult.prossesingStatus = CreditCardMdl.CreditCardProcessStatus.Finished;
            

                dispatch({ type: 'CREDITCARD_FS_CHARGERESULT', newState: creditCardResult });
            })
            .catch(function (err: Error) {
                dispatch({
                    type: 'CREDITCARD_FS_ERROR', error: err.message
                })
            });
    },
    retrieveStoredCards: (pSessionModel: SessionModel): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState = appState.sessionState;
      
        dispatch({ type: 'CREDITCARD_FS_PROCESSING' });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + `api/Proxy/FullSteamGetCards?pCompanyCode=${sessionState.SelectedAR.companyCode}&pCustomerCode=${sessionState.SelectedAR.id}`,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
               
                if (container.success) {
                    const data: CreditCardMdl.CreditCardModel[] = container.data;
                   
                    dispatch({ type: 'CREDITCARDS_FS_LOAD', newState: data});                    
                } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                }
            });


    },
    retrieveAuthenticationKey: (pSessionModel: SessionModel): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState = appState.sessionState;        
        dispatch({ type: 'CREDITCARD_FS_PROCESSING' });
        var payload = { "pCompanyCode": sessionState.SelectedAR.companyCode }
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + `api/Proxy/GetFSAuthenticationKey`,
            {               
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
               
                if (container.success) {
                    const data: CreditCardMdl.AuthKeyReponse = {
                        ...CreditCardMdl.initialValueAuthKeyReponse, ...container.data
                    };
                   
                    dispatch({ type: 'CREDITCARDS_FS_AK_LOADED', authKey: data.authenticationKey, hostedFormScript: data.hostedPaymentURL });
                } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                }
            });


    },
    chargeWithNewCreditCard: (jsonResult: any): AppThunkAction<KnownAction> => (dispatch, getState) => {

        console.log("ChargeNewCreditCard IN")
        const appState = getState();
        const sessionState = appState.sessionState;
        const invoicesAR: ARInvoiceMdl.ArInvoiceModel[] = appState.openInvoicesState.items.filter(x => x.isSelectedToPay == true);
        var ChargeInvoiceMdl: CreditCardMdl.ChargeWithNewCardMultipleRecordsPayload = CreditCardMdl.initialStateChargeWithNewCardMultipleRecordsPayload;
        var invoicesToCharge: CreditCardMdl.ChargeWithTokenInvoice[] = [];
        var totalAmount: number = 0;
        var fee: number = 0;
        invoicesToCharge = invoicesAR.map((item, index) => {
            totalAmount += item.balanceDue;
            fee += item.programFee;
            return {
                invoiceNum: item.invoiceNumber,
                amount: item.balanceDue,
                programFee: item.programFee,
                module: 'AR' //item.module
            };
        });
       
        if (fee > 0) {
            totalAmount += fee;
        }


        console.log(invoicesToCharge);

        console.log(jsonResult.jsonStrResult);

     
        var resultObj = JSON.parse(jsonResult.jsonStrResult);

      

        ChargeInvoiceMdl = {
            ...CreditCardMdl.initialStateChargeWithNewCardMultipleRecordsPayload, ...{
                invoices: invoicesToCharge,
                newCardName: resultObj.requestDetails.nameOnAccount,                
                newCardLast4: resultObj.requestDetails.cardNumber,
                newCardToken: resultObj.gatewayResponse.hostedPaymentsAccountId,
                companyCode: sessionState.SelectedAR.companyCode,                
                entityCode: 'Customer',
                entityType: 'C',
                amountToCharge: totalAmount,                
                billTo: sessionState.SelectedAR.id,
                userNumber: '',
                userName: 'Customer-Portal',
                sendReceiptToEmail: '',
                sendReceiptToPhone: '',
                userType: 'C',
                transactionFee: fee,
                comments: '',
                storeCard: jsonResult.storeCard
            }
        };

        dispatch({ type: 'CREDITCARD_FS_PROCESSING' });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/Proxy/FullSteamChargeWithNewCard',
            {
                method: 'POST',
                body: JSON.stringify(ChargeInvoiceMdl),
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
                console.log(container.data);
                const data: CreditCardMdl.ChargeWithTokenResult = { ...container.data };
                var creditCardResult: CreditCardMdl.CreditCardFSProcess = { ...CreditCardMdl.CreditCardProcessIntialState };
                console.log(`Data Success ${data.success}`)
                console.log(`Error ${container.errorInfo ? container.errorInfo.message : ''}`)
                creditCardResult.error = container.errorInfo ? container.errorInfo.message : '';
                creditCardResult.success = data.success;
                creditCardResult.prossesingStatus = CreditCardMdl.CreditCardProcessStatus.Finished;
                console.log(`ReceiptLInk ${data.receiptLink}`)
                creditCardResult.receiptLink = data.receiptLink;
                console.log(`ReceiptLInk REsult ${creditCardResult.receiptLink}`)

                dispatch({ type: 'CREDITCARD_FS_CHARGERESULT', newState: creditCardResult });
            })
            .catch(function (err: Error) {
                dispatch({
                    type: 'CREDITCARD_FS_ERROR', error: err.message
                })
            });
    },
};


export const reducer: Reducer<CreditCardMdl.CreditCardFSProcess> = (state: CreditCardMdl.CreditCardFSProcess | undefined, incomingAction: Action): CreditCardMdl.CreditCardFSProcess => {

    if (state === undefined) {
        return { ...CreditCardMdl.CreditCardProcessIntialState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'CREDITCARD_FS_PROCESSING':
            return { ...state, prossesingStatus: CreditCardMdl.CreditCardProcessStatus.InProcesses }
        case 'CREDITCARD_FS_CHARGERESULT':
            const chargeCreditCardAction = incomingAction as ChargeCreditCardFS;
            return { ...chargeCreditCardAction.newState, prossesingStatus: CreditCardMdl.CreditCardProcessStatus.Finished }
        case 'CREDITCARD_FS_ERROR':
            const chargeCreditErrorAction = incomingAction as ChargeCreditErrorFS;
            return { ...state, prossesingStatus: CreditCardMdl.CreditCardProcessStatus.Finished, error: chargeCreditErrorAction.error, success: false }
        case 'CREDITCARD_FS_RESETINFO':
            return { ...CreditCardMdl.CreditCardProcessIntialState };      
        case 'CREDITCARDS_FS_LOAD':
            const chargeStoredCreditCard = incomingAction as CreditCardsLoadFS;          
            return { ...state, prossesingStatus: CreditCardMdl.CreditCardProcessStatus.NotStarted, storedCreditCards: chargeStoredCreditCard.newState, storedCreditCardsLoaded: true};
        case 'CREDITCARDS_FS_AK_LOADED':
            const inAuthKey = incomingAction as CreditCardsAuthKeyLoaded;
            return { ...state, authKey: inAuthKey.authKey, hostedFormURL: inAuthKey.hostedFormScript, prossesingStatus: CreditCardMdl.CreditCardProcessStatus.NotStarted};

        default:
            return state;
    }
}; 